import React from 'react';
import PricingSection from '../components/PricingSection';

const Pricing = () => {
  return (
    <div className="bg-[#050505] pt-44 pb-32 px-6">
      <div className="max-w-7xl mx-auto">
        <PricingSection showHeader={true} />
      </div>
    </div>
  );
};

export default Pricing;